import { FolderPick, Kind, MIME_KIND_MAP, ServiceProvider } from '../..';

export const UPLOADCAM_FOLDER_MIME = 'application/vnd.uploadcam.folder';
export const UPLOADCAM_UNKNOWN_MIME = 'application/vnd.uploadcam.unknown';

export enum StorageItemType {
  File = 'file',
  Folder = 'folder',
}

// Fly `Visibility.php`
export enum Visibility {
  Public = 'public',
  Private = 'private',
}

export type StorageItemMetadata = Record<string, any>;

export interface BasicStorageItem {
  provider: ServiceProvider;
  driveId: string | undefined;
  id: string;
}

export interface StorageItem extends BasicStorageItem {
  isVirtual: boolean;
  kind: Kind;
  name: string;
  type: StorageItemType;
  parentId?: string;
  // visibility: Visibility | undefined;
  lastModified: Date | undefined;
  isFile: boolean;
  isFolder: boolean;
  /** Can folder be created inside this item? */
  allowsSubfolderCreation: boolean;
  mime: string;
  metadata: StorageItemMetadata;
  /** Size in bytes */
  size: number | undefined;
  toFolderPick(): FolderPick;
}

export abstract class BaseStorageItem implements StorageItem {
  abstract get id(): string;
  abstract get provider(): ServiceProvider;
  abstract get parentId(): string | undefined;
  abstract get driveId(): string | undefined;
  abstract get allowsSubfolderCreation(): boolean;
  abstract get isVirtual(): boolean;
  abstract get lastModified(): Date | undefined;
  abstract get metadata(): StorageItemMetadata;
  abstract get mime(): string;
  abstract get name(): string;
  // abstract get visibility(): Visibility | undefined;
  abstract get size(): number | undefined;

  get isFile(): boolean {
    return this.type === StorageItemType.File;
  }

  get isFolder(): boolean {
    return this.type === StorageItemType.Folder;
  }

  get kind(): Kind {
    const mimeKind = MIME_KIND_MAP.get(this.mime);

    if (mimeKind) {
      return mimeKind;
    }

    if (this.isFolder) {
      return Kind.Folder;
    }

    return Kind.Unknown;
  }

  get type(): StorageItemType {
    if (this.mime === UPLOADCAM_FOLDER_MIME) {
      return StorageItemType.Folder;
    } else {
      return StorageItemType.File;
    }
  }

  public toFolderPick(): FolderPick {
    return {
      driveId: this.driveId,
      id: this.id,
      name: this.name,
    };
  }
}
